<template>
  <div :class="'base-create'">
    <el-button @click="removeAssignment" v-if="index != 0" class="remove-assignment">
      <font-awesome-icon :icon="['fas', 'trash-alt']" style="color: #eb5757; font-size: 14px; line-height: 14px" />
    </el-button>
    <el-form :rules="rules" :model="assignment" class="create-edit-form" ref="firstForm" hide-required-asterisk>
      <el-row :gutter="24" class="form-row">
        <el-col :md="12" :xs="24">
          <elsa-input
            v-model="assignment.name"
            :label="$t('study_sets.assignment_name')"
            :placeholder="$t('study_sets.form.name_your_assignment')"
            name="name"
            class="required"
          />
        </el-col>
        <el-col :md="12" :xs="24">
          <elsa-tree-select
            name="groupId"
            :label="$t('study_sets.assigned_to')"
            :placeholder="$t($i18nLabelsHelper(currentOrganizationType, 'select_group'))"
            :options="classes"
            v-model="groupIds"
            @clear="onClearClassHandler"
          />
        </el-col>
      </el-row>
      <el-row :gutter="24" class="input-wrapper-assessment">
        <el-col :md="12" :xs="24">
          <elsa-date
            :information="$t('homework.tooltip.start_date')"
            v-model="assignment.startDate"
            value-format="yyyy-MM-dd"
            format="dd/MM/yyyy"
            type="date"
            name="startDate"
            :label="$t('homework.form.start_date')"
            placeholder="dd/mm/yy"
            :picker-options="pickerOptions"
            class="required"
          >
          </elsa-date>
        </el-col>
        <el-col :md="12" :xs="24">
          <elsa-select
            name="startTime"
            popper-class="emails-list-popover"
            :options="timeOptionsStart"
            :label="$t('homework.form.start_time')"
            placeholder="00:00"
            v-model.lazy="assignment.startTime"
            filterable
            clearable
            v-on:change="onStartTimeChange"
            class="required"
          />
        </el-col>
      </el-row>
      <el-row :gutter="24" class="input-wrapper-assessment">
        <el-col :md="12" :xs="24">
          <elsa-date
            :information="$t('homework.tooltip.due_date')"
            v-model="assignment.dueDate"
            type="date"
            value-format="yyyy-MM-dd"
            format="dd/MM/yyyy"
            name="dueDate"
            :label="$t('homework.form.due_date')"
            class="required"
            placeholder="dd/mm/yy"
            v-on:change="onEndDateChange"
            :picker-options="pickerOptions"
          >
          </elsa-date>
        </el-col>
        <el-col :md="12" :xs="24">
          <elsa-select
            name="dueTime"
            popper-class="emails-list-popover"
            :options="timeOptionsDue"
            :label="$t('homework.form.due_time')"
            placeholder="00:00"
            v-model.lazy="assignment.dueTime"
            filterable
            clearable
            class="required"
          />
        </el-col>
      </el-row>
      <el-row :gutter="24" class="form-row">
        <el-col :md="6" :xs="24">
          <span class="set-reminder">{{ $t("homework.set_reminder") }} </span>
          <el-tooltip :content="$t('homework.tooltip.set_reminder')" placement="top-start"
            ><i class="el-icon-info"
          /></el-tooltip>
        </el-col>
        <el-col :md="6" :xs="24">
          <hr />
        </el-col>
      </el-row>
      <el-row :gutter="24" class="input-wrapper-reminder">
        <el-col :md="12" :xs="24">
          <elsa-input-number
            v-model="assignment.reminderBeforeDay"
            controls-position="right"
            :min="0"
            :max="maxReminderBeforeDay"
            :disabled="!assignment.dueDate"
            :followInfo="$t('homework.form.before_the_due_date')"
            :placeholder="$t('homework.form.0_day')"
            :formatter="reminderBeforeDayFormatter"
            :invertFormatter="reminderBeforeDayInvertFormatter"
            style="text-align: center"
          ></elsa-input-number>
        </el-col>
        <el-col :md="6" :xs="24">
          <elsa-time
            v-model="assignment.timeNotify"
            name="timeon"
            class="first-assessment elsa-input"
            placeholder="00:00"
            format="HH:mm A"
            value-format="hh:mm"
            :picker-options="timeOptions"
          >
          </elsa-time>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="input-wrapper-assessment">
        <el-col :md="12" :xs="24">
          <elsa-select
            name="shareable"
            :information="$t('homework.form.asignment_shareable_tooltip')"
            :placeholder="$t('homework.form.shareable')"
            :options="shareableOptions"
            :label="$t('homework.form.shareable')"
            v-model.lazy="assignment.shareable"
            filterable
            clearable
          />
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import ElsaInput from "@/components/common/Input";
import ElsaInputNumber from "@/components/common/InputNumber";
import ElsaDate from "@/components/common/dateInput";
import ElsaTime from "@/components/common/timeInput";
import { getHours, getMinutes } from "date-fns";
import { handleFormValidation } from "../../../../helpers/formValidationHelper";
import { mapGetters, mapActions } from "vuex";
import ElsaSelect from "@/components/common/Select";
import ElsaTreeSelect from "@/components/common/TreeSelect";
import { path, pathOr } from "ramda";
import axios from "@/utils/axios";
import { generateTimeOption } from "@/helpers/timeHelper";

export default {
  components: {
    ElsaInput,
    ElsaInputNumber,
    // DatePicker,
    // ElsaSearch,
    ElsaSelect,
    ElsaDate,
    ElsaTime,
    ElsaTreeSelect
  },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    defaultDateReminder: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      form: {
        name: path(["assignment", "name"])(this),
        groupIds: path(["assignment", "groupIds"])(this),
        startDate: path(["assignment", "startDate"])(this),
        dueDate: path(["assignment", "dueDate"])(this),
        startTime: path(["assignment", "startTime"])(this),
        dueTime: path(["assignment", "dueTime"])(this),
        reminderBeforeDay: path(["assignment", "reminderBefore"])(this),
        timeNotify: path(["assignment", "timeNotify"])(this),
      },
      rules: {
        name: { required: true, type: "string", message: this.$t("study_sets.errors.please_provide_name") },
        groupIds: {
          required: true,
          message: this.$t(this.$i18nLabelsHelper(this.organizationType, "errors.please_select_team")),
        },
        startDate: { required: true, message: this.$t("study_sets.errors.please_provide_start_on") },
        dueDate: { required: true, message: this.$t("study_sets.errors.please_provide_due_on") },
        startTime: { required: true, message: this.$t("homework.errors.please_provide_start_time") },
        dueTime: { required: true, message: this.$t("homework.errors.please_provide_due_time") },
      },
      modals: {
        showInviteTeacherModal: false,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 1 * 86400000;
        },
      },
      loadingClasses: false,
      classes: [],
      admins: [],
      timeOptionsStart: [],
      timeOptionsDue: [],
      timeOptions: {
        start: "00:00",
        step: "00:15",
        end: "23:30",
      },
      maxReminderBeforeDay: 1,
      shareableOptions: [
        { value: "branch_only", label: "Branch" },
        { value: "organization", label: "My Organization" },
        { value: "class", label: "Class Only" },
      ],
      selectAllVal: false,
      groupIds: []
    };
  },
  computed: {
    ...mapGetters({
      buildingAssignments: "readAlouds/getBuildingAssignments",
      currentOrganizationType: "organization/currentOrganizationType",
      isElsaAdmin: "user/isElsaAdmin",
      isAdminOfAnOrgHasBranches: 'organization/isAdminOfAnOrgHasBranches',
    }),
    assignments() {
      return pathOr([], ["buildingAssignments", "assignments"])(this);
    },
    assignment() {
      if (this.assignments && this.assignments.length > this.index) {
        return this.assignments[this.index];
      }
      return null;
    },
    organizationId() {
      return this.$store.state.organization.currentOrganizationId;
    },
    dateObject() {
      return {
        start: this.classDetails.startDate ? new Date(this.classDetails.startDate) : "",
        end: this.classDetails.endDate ? new Date(this.classDetails.endDate) : "",
      };
    },
  },

  async mounted() {
    this.timeOptionsStart = this.timeOptionsDue = generateTimeOption();
    if (this.isElsaAdmin) {
      this.shareableOptions.push({ value: "public", label: "Public" });
    }
    try {
      this.assignment.reminderBeforeDay = 0;
      this.searchGroup("");
    } catch (error) {
      error;
    }
  },
  methods: {
    ...mapActions({
      createAssignments: "readAlouds/createAssignments",
      updateBuildingAssignments: "readAlouds/updateBuildingAssignments",
      resetAssignments: "readAlouds/resetBuildingAssignments",
    }),
    reset() {
      this.loadingClasses = false;
      this.classes = [];
      this.admins = [];
    },
    removeAssignment() {
      let buildingAssignments = this.buildingAssignments;
      let assignments = [];
      for (let i = 0; i < buildingAssignments.assignments.length; i++) {
        if (i != this.index) {
          assignments.push(buildingAssignments.assignments[i]);
        }
      }
      this.updateBuildingAssignments({
        assignments: assignments,
      });
    },
    reminderBeforeDayFormatter(v) {
      if (v > 1) {
        return `${v} ${this.$t("common.days")}`;
      } else {
        return `${v} ${this.$t("common.day")}`;
      }
    },
    reminderBeforeDayInvertFormatter(v) {
      return v.trim().split(" ")[0];
    },
    handleContinueClick() {
      handleFormValidation(this.$refs.firstForm, this.validFormCallback, () => {});
    },

    validFormCallback() {
      this.$emit("next-step", this.currentStep);
    },
    handleCancelClick() {
      return this.$router.push({
        name: "classes",
        params: {
          organizationId: this.currentOrganizationId,
        },
      });
    },
    openInviteTeacherModal() {
      this.modals.showInviteTeacherModal = true;
    },
    onStartTimeChange() {
      if (this.assignment.startDate && this.assignment.startTime == "now") {
        this.assignment.assign_now = true;
      }
    },
    onEndDateChange() {
      if (this.assignment.dueDate && this.assignment.startDate) {
        let first = Date.parse(this.assignment.startDate);
        let second = Date.parse(this.assignment.dueDate);
        this.assignment.reminderBeforeDay = this.maxReminderBeforeDay =
          Math.round((second - first) / (1000 * 60 * 60 * 24)) - 1;
      }
      if (!this.assignment.dueDate && this.assignment.reminderBeforeDay != this.defaultDateReminder) {
        let buildingAssignments = this.buildingAssignments;
        let assignments = [];
        for (let i = 0; i < buildingAssignments.assignments.length; i++) {
          if (i == this.index) {
            assignments.push({ ...buildingAssignments.assignments[i], reminderBeforeDay: 5 });
          } else {
            assignments.push(buildingAssignments.assignments[i]);
          }
        }
        this.updateBuildingAssignments({
          assignments: assignments,
        });
      }
    },
    async remoteSearchGroups(query) {
      if (query !== "") {
        this.loadingClasses = true;
        try {
          await this.searchGroup(query);
        } catch (err) {
          err;
        } finally {
          this.loadingClasses = false;
        }
      } else {
        this.options = [];
      }
    },
    searchGroup(search) {
      return this.getGroup({ search });
    },
    async getGroup({ page = 1, search = null, status = "" }) {
      this.loadingClasses = true;
      const organizationId = this.organizationId;
      let params = { page, search, status };
      let url = `/v1/organizations/${organizationId}/all-groups`

      if (this.isAdminOfAnOrgHasBranches) {
        url = `/v1/organizations/${organizationId}/all-classes/grouped`
      }

      const { data } = await this.$axios.get(url, { params });

      this.loadingClasses = false;

      if (!this.isAdminOfAnOrgHasBranches) {
        this.classes = data.map(x => {
          return { label: x.name, id: x.id };
        });

        return
      }

      const { parent, branches } = data
      let parentClasses = []
      let branchClasses = []

      if (parent) {
        parentClasses = parent.classes.map((cls) => {
          return {
            id: cls.id,
            label: cls.name,
          }
        })
      }

      if (branches) {
        branchClasses = branches.map((branch) => {
          return {
            id: branch.id,
            label: branch.name,
            children: branch.classes.map(cls => ({
              id: cls.id,
              label: cls.name,
            })
          )}
        })
      }

      this.classes = [ ...parentClasses, ...branchClasses ]
    },
    handleSelectAll(val) {
      if (val) {
        this.assignment.groupIds = this.classes.map(clazz => clazz.value);
        this.selectAllVal = true;
      } else {
        this.assignment.groupIds = "";
        this.selectAllVal = false;
      }
    },
    onClearClassHandler() {
      this.groupIds = []
    }
  },
  watch: {
    "assignment.startDate"(new_value) {
      if (Date.parse(new Date()) - Date.parse(new_value) > 0) {
        const hourAddition = Math.ceil(getMinutes(Date.now()) / 15) / 4;
        const assign_now_op = true;
        this.timeOptionsStart = generateTimeOption(getHours(Date.now()) + hourAddition, assign_now_op);
      } else {
        this.timeOptionsStart = generateTimeOption(0);
      }
    },
    "assignment.dueDate"(new_value) {
      if (Date.parse(new Date()) - Date.parse(new_value) > 0) {
        const hourAddition = Math.ceil(getMinutes(Date.now()) / 15) / 4;
        this.timeOptionsDue = generateTimeOption(getHours(Date.now()) + hourAddition);
      } else {
        this.timeOptionsDue = generateTimeOption(0);
      }
    },
    "assignment.groupIds"(new_value) {
      if (new_value.length == this.classes.length && new_value.length > 0) {
        this.selectAllVal = true;
      } else {
        this.selectAllVal = false;
      }
    },
    groupIds(ids) {
      this.assignment.groupIds = ids
    }
  },
};
</script>

<style lang="scss" scoped>
.form-row {
  margin-top: 20px;
}

.remove-assignment {
  position: absolute;
  right: 0px;
  top: -20px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
}

.base-create {
  padding: 0px 0px;
  position: relative;
}

.pick-teacher {
  font-weight: 600;
  font-size: 14px;
  color: #478dff;
  flex: 1;

  .invite-teacher {
    cursor: pointer;
    margin-top: 16px;
    float: left;
  }
}

.input-wrapper-reminder {
  margin-top: 24px;
  &::v-deep .el-icon-time:before {
    content: "at";
    font-size: 16px;
    line-height: 24px;
    font-family: "SF Pro Display";
  }
}

hr {
  border: 1px solid #e5e5ea;
  margin-top: 12px;
}

.set-reminder {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: #121131;
}

.create-edit-form .form-row .el-form-item.elsa-input:not(:last-of-type) {
  margin-right: 0;
}

::v-deep .elsa-section {
  background-color: #f2f7fa;
}
::v-deep .el-date-editor.el-input {
  width: 200px;
}
::v-deep .elsa-input .el-input .el-input__inner {
  width: 100%;
}
::v-deep .el-date-editor.el-input {
  width: 100% !important;
}

::v-deep .el-form {
  padding-bottom: 0px;
}
::v-deep .el-input-number .el-input input {
  text-align: left;
  text-transform: lowercase;
}

::v-deep .el-form .el-form-item .el-form-item__label {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: #121131;
}
::v-deep .required .el-form-item__label::after {
  content: "*";
  margin-left: 2px;
  color: #eb5757;
}
::v-deep .el-form-item__label::before {
  content: "";
}
::v-deep .el-form .el-form-item {
  margin-bottom: 32px;
}
.elsa-input {
  &::v-deep .el-input .el-input__inner {
    height: 48px !important;
  }
}
::v-deep .el-input__icon {
  line-height: 30px !important;
}

::v-deep .el-icon-info:before {
  color: #8e8e93;
  margin-left: 8px;
}

::v-deep .input-wrapper-reminder .el-form-item__label:after {
  content: unset;
}
</style>
